import { render } from "./A3Data.vue?vue&type=template&id=9ac3ae28&scoped=true"
import script from "./A3Data.vue?vue&type=script&lang=js"
export * from "./A3Data.vue?vue&type=script&lang=js"

import "./A3Data.vue?vue&type=style&index=0&id=9ac3ae28&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac3ae28"]])

export default __exports__